import React, { FC } from "react";
import { ThemeProvider } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { DataContext, DataProvider } from "./DataContext";
import { LoadingContext, LoadingProvider } from "./LoadingContext";
import { FiltersContext, FiltersProvider } from "./FiltersContext";
import { VisibilityContext, VisibilityProvider } from "./VisibilityContext";
import { TherapeuticAreaContext, TherapeuticAreaProvider } from "./TherapeuticAreaContext";
import theme from "../utils/theme";

const AppContext: FC = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <LoadingProvider>
      <VisibilityProvider>
        <DataProvider>
          <TherapeuticAreaProvider>
            <FiltersProvider>{children}</FiltersProvider>
          </TherapeuticAreaProvider>
        </DataProvider>
      </VisibilityProvider>
    </LoadingProvider>
  </ThemeProvider>
);

export { AppContext, LoadingContext, FiltersContext, VisibilityContext, DataContext, TherapeuticAreaContext };
